import React from 'react'
import { LiaIdCardSolid, LiaPlusCircleSolid } from "react-icons/lia";
import { IoHome } from "react-icons/io5";
import { MdRecordVoiceOver } from "react-icons/md";

function DashboardCategory({handleDisplay, whatToDisplay}) {

    const handleClick = (e) => {
      
        const show = e.target.id || e.target.parentElement.id
        handleDisplay(show)
    }

  return (
    <div className={`bg-[#101010] text-white flex mt-7 rounded-t-2xl mx-3 sm:mx-0`}>
      <div className={`w-[25%] flex justify-center
       ${whatToDisplay === "user-cards" ? "bg-[#101010]" : "bg-[#272727]" }
        `}>
        <button
        id="user-cards"
        onClick={handleClick}
        className='sm:text-xl w-full py-5 flex justify-center'>
        <p className='hidden sm:block'>User Cards</p>
        <LiaIdCardSolid 
        id="user-cards"
        onClick={handleClick}
        className='sm:hidden text-3xl' />
        </button>
      </div>
      
      <div className={`w-[25%] flex justify-center
        ${whatToDisplay === "feed" ?  "bg-[#101010]" : "bg-[#272727]" }
        prounded-tr-2xl`}>
      <button 
      id="feed"
      onClick={handleClick}
      className='sm:text-xl w-full py-5 flex justify-center'>
      
      <p className='hidden sm:block'>Feed</p>
      <IoHome 
      id="feed"
      onClick={handleClick}
      className='sm:hidden text-3xl' />
      </button>
      </div>

      <div className={`w-[25%] flex justify-center
        ${whatToDisplay === "create" ?  "bg-[#101010]" : "bg-[#272727]" }
        prounded-tr-2xl`}>
      <button 
      id="create"
      onClick={handleClick}
      className='sm:text-xl w-full py-5 flex justify-center'>
      <p className='hidden sm:block'>Create</p>
      <LiaPlusCircleSolid
      id="create"
      onClick={handleClick} 
       className='sm:hidden text-3xl' />
      </button>
      </div>

      <div className={`w-[25%] flex justify-center
        ${whatToDisplay === "debates" ?  "bg-[#101010]" : "bg-[#272727]" }
        prounded-tr-2xl`}>
      <button 
      id="debates"
      onClick={handleClick}
      className='sm:text-xl w-full py-5 flex justify-center'>
      <p className='hidden sm:block'>Debates</p>
      <MdRecordVoiceOver       
      id="debates"
      onClick={handleClick} 
      className='sm:hidden text-3xl' />
      </button>
      
      </div>
    </div>
  )
}

export default DashboardCategory
